import { Button } from '@finpay-development/shared-components';
import { Grid, Typography, Button as MUIButton, Box, Checkbox, FormControlLabel } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import type { PaymentProgramViewContext } from './use-payment-program-view';

interface CustomProgramViewProps {
  ctx: PaymentProgramViewContext;
}

/**
 * First step of the custom flow: prompt user to choose down payment and/or recurring payment,
 * then click Next to go to custom-results.
 */
export function CustomProgramView({ ctx }: CustomProgramViewProps) {
  const {
    billingFrequency,
    showDownPayment,
    setShowDownPayment,
    showRecurringAmount,
    setShowRecurringAmount,
    patientId,
    encounterId,
    getProgramPath,
    navigate,
    handleBack,
  } = ctx;

  const paymentLabel = billingFrequency === 'weekly' ? 'weekly payment' : 'monthly payment';

  return (
    <Grid item xs={12}>
      <Grid container className="mt-4" spacing={2}>
        <Grid item xs={12}>
          <Typography variant="body2" textAlign="left" sx={{ mb: 1, fontSize: '2rem', lineHeight: '2.6rem' }}>
            No problem, is it the down payment, the {paymentLabel} or both that doesn't work for you?
            <br />
            <br />
            <Box component="span" sx={{ fontStyle: 'italic' }}>
              Select all that apply.
            </Box>
          </Typography>
        </Grid>
        <Grid item xs={12} sx={{ mt: -1 }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={showDownPayment}
                onChange={(e) => setShowDownPayment(e.target.checked)}
                test-id="show-down-payment-checkbox"
              />
            }
            label="Down Payment"
          />
        </Grid>
        <Grid item xs={12} sx={{ mt: -1, mb: 3 }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={showRecurringAmount}
                onChange={(e) => setShowRecurringAmount(e.target.checked)}
                test-id="show-recurring-amount-checkbox"
              />
            }
            label="Recurring Payment"
          />
        </Grid>
      </Grid>

      <Grid container spacing={1} alignItems="center">
        <Grid item xs={12} md={2} className="mt-2">
          <MUIButton
            onClick={handleBack}
            variant="outlined"
            fullWidth
            sx={{
              backgroundColor: 'white',
              borderColor: '#e0e0e0',
              color: '#000',
              '&:hover': {
                backgroundColor: '#f5f5f5',
                borderColor: '#bdbdbd',
              },
            }}
          >
            <ArrowBackIosIcon sx={{ fontSize: '1rem', mr: 0.5 }} /> Back
          </MUIButton>
        </Grid>
        <Grid item xs={12} md={10} className="mt-2">
          <Button
            onClick={() => {
              if (showDownPayment || showRecurringAmount) {
                navigate(getProgramPath(`/hub/patient/${patientId}/ioc/${encounterId}/program/custom-results`), {
                  state: { showDownPayment, showRecurringAmount },
                });
              }
            }}
            fullWidth
            disabled={!showDownPayment && !showRecurringAmount}
            test-id="payment-program-custom-next"
          >
            Next
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
}
